import React from 'react';
import PropTypes from 'prop-types';
import { CoreCard } from '../library/card';
import './card.scss';

/**
 * Styled card. Extends [CoreCard](#corecard).
 */
export default function Card({
	className, children, hideBorder, dark
}) {
	return (
		<CoreCard
			className={className}
			hideBorder={hideBorder}
			dark={dark}
		>
			{children}
		</CoreCard>
	);
}

Card.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
	hideBorder: PropTypes.bool,
	dark: PropTypes.bool
};
